<template>
  <div class="account-register">
    <div class="account-register__socials">
      <form-socials title="Sign Up with" v-if="!isWrapperApp"></form-socials>
    </div>
    <form-errors :errors="errors"></form-errors>
    <form @submit.prevent="onSubmit">
      <div class="row-xy">
        <div class="column small-12">
          <h5 class="form__title form__title--new">Sign Up using your email</h5>
        </div>
        <div class="column small-12 row-y">
          <div class="column small-12">
            <form-input
              v-model="fields.email"
              :tabindex="1"
              @input="$v.fields.email.$touch"
              :disabled="isFormDisabled"
              name="username"
              type="email"
              :required="true"
              :validation="$v.fields.email"
              autocomplete="off"
              gtm="Registration,Email"
              placeholder="Email"
            >
            </form-input>
          </div>
          <div class="column small-12">
            <form-input
              v-model="fields.emailConfirmation"
              :tabindex="2"
              @input="$v.fields.emailConfirmation.$touch"
              :disabled="isFormDisabled"
              name="emailConfirmation"
              type="email"
              :required="true"
              :validation="$v.fields.emailConfirmation"
              autocomplete="off"
              gtm="Registration,Confirm Email"
              placeholder="Confirm Email"
            >
            </form-input>
          </div>
          <div class="column small-12">
            <form-input
              v-model="fields.password"
              :hideIconOnValue="false"
              ref="password"
              :tabindex="3"
              @input="$v.fields.password.$touch"
              :disabled="isFormDisabled"
              name="password"
              :type="fieldTypePassword"
              :required="true"
              :validation="$v.fields.password"
              autocomplete="new-password"
              gtm="Registration,Password"
              placeholder="Password"
            >
              <template v-slot:icon>
                <show-password-icon v-if="!isIE" @showPassword="showPassword"></show-password-icon>
              </template>
            </form-input>
          </div>
          <template v-if="showUsername">
            <div class="column small-12">
              <div class="account-register__username-wraper">
                <form-input
                  v-model="fields.username"
                  @input="$v.fields.username.$touch"
                  :tabindex="4"
                  :disabled="isFormDisabled"
                  name="nickname"
                  type="text"
                  :required="true"
                  :validation="$v.fields.username"
                  autocomplete="off"
                  gtm="Registration,User Name"
                  placeholder="Username"
                >
                </form-input>
              </div>
            </div>
          </template>
        </div>
        <div class="column small-12">
          <p class="account-register__disclaimer">
            By clicking "Create Account", you confirm that you are at least 18 years of age and have
            read the
            <router-link v-outer-link :to="{ name: 'terms-and-conditions' }"
              >Terms and Conditions</router-link
            >. One account per person.
          </p>
        </div>
      </div>
      <form-submit
        :disabled="registerButtonDisabled"
        :loading="isFormDisabled"
        label="Create Account"
      ></form-submit>
      <div class="recaptcha-terms">
        Protected by reCAPTCHA ·
        <a href="https://policies.google.com/privacy" v-outer-link>Privacy</a>
        ·
        <a href="https://policies.google.com/terms" v-outer-link>Terms</a>
      </div>
    </form>
  </div>
</template>

<script src="./account-register.js"></script>
<style src="./account-register.scss" lang="scss"></style>
